import React, { Component } from 'react';
import { Main, ButtonLink, Heading, FormRow, SubHeading } from '../../styles/style';

class Welcome extends Component {
  render() {
    return (
      <Main>
      	{/*
        <SubHeading>Get access to the online On the Table planning tool</SubHeading>
        <FormRow><ButtonLink to="/host/register">Register to Host</ButtonLink></FormRow>
				<FormRow><ButtonLink to="/host/signin" target="_parent">Already Registered? Host Sign In</ButtonLink></FormRow>
        */}
        <SubHeading>Get news and updates about On the Table</SubHeading>
        <FormRow><ButtonLink to="/host/newsletter">Stay Informed</ButtonLink></FormRow>
      </Main>
    )
  }
}

export default Welcome
